import React, { FunctionComponent, ReactNode } from 'react';
import { NextRouter, withRouter } from 'next/router';
import data from '../../../data/common.yml';
import Footer from '../../components/footer/Footer';
import AppNavigation from '../../templates/common/app-navigation/AppNavigation';
import SiteLayout from '../site-layout/SiteLayout';
import { AppNavigationVariant } from '../../templates/common/app-navigation/types';

const {
  leadPhone,
  callCenterWhatsApp,
  footer,
} = data;

export interface LandingLayoutProps {
  navigationVariant?: AppNavigationVariant,
  children: ReactNode,
  router: NextRouter,
}

export const LandingLayout: FunctionComponent<LandingLayoutProps> = ({
  navigationVariant,
  children,
}) => (
  <SiteLayout
    render={{
      header: (
        <AppNavigation
          whatsApp={callCenterWhatsApp}
          phone={leadPhone}
          items={[]}
          hideActions
          variant={navigationVariant}
        />
      ),
      footer: (
        <Footer
          whatsApp={callCenterWhatsApp}
          tagline={footer.tagline}
          {...footer}
          links={[]}
        />
      ),
    }}
  >
    {children}
  </SiteLayout>
);

export default withRouter((LandingLayout));
